// extracted by mini-css-extract-plugin
export default {"filters":"TagsScreen_filters__T3-25"};